import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactSection from '../components/Contact';

const KontakPage = () => {
  useEffect(() => {
    document.title = 'Kontak — Werdi Media';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App bg-[#0a0a0a] min-h-screen">
      <Navbar />

      {/* Page hero */}
      <section className="relative pt-32 pb-10 lg:pt-40 lg:pb-14 overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-1/4 -left-32 w-[500px] h-[500px] rounded-full bg-[#D4A94F]/10 blur-[120px]" />
          <div className="absolute bottom-0 -right-32 w-[600px] h-[600px] rounded-full bg-[#B8892C]/8 blur-[130px]" />
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-neutral-500 hover:text-[#E9C46A] link-transition mb-10"
          >
            <ArrowLeft className="w-3 h-3" /> Beranda
          </Link>

          <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-6">
            <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
              Hubungi Kami
            </span>
          </div>

          <h1 className="text-white font-bold text-4xl md:text-6xl leading-[1.05] tracking-tight mb-5">
            Kontak <span className="gold-gradient-text">Werdi Media</span>
          </h1>

          <p className="text-neutral-400 text-lg md:text-xl leading-relaxed max-w-2xl mb-10">
            Kirim pesan langsung ke tim kami atau gunakan kanal kontak yang paling
            mudah untuk Anda. Kami biasanya membalas dalam satu hari kerja.
          </p>
        </div>
      </section>

      <ContactSection className="pt-0 pb-24 lg:pb-32" />

      <Footer />
    </div>
  );
};

export default KontakPage;